import React, { useEffect, useState } from 'react';

const Counter = ({ end, duration = 1200, suffix = '%' }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);
    let raf;
    function animate() {
      start += increment;
      if (start < end) {
        setValue(Math.floor(start));
        raf = requestAnimationFrame(animate);
      } else {
        setValue(end);
      }
    }
    animate();
    return () => cancelAnimationFrame(raf);
  }, [end, duration]);

  return <span>{value}{suffix}</span>;
};

export default Counter;
